export default __webpack_public_path__ + "0ce22073e40048a2c0544b2e2038af5a.png";